import CurrencyUtil from '@utils/CurrencyUtil';
import moment from 'moment';
import numeral from 'numeral';

export default {

    random(len) {
        return Math.random().toString(36).replace(/[^A-za-z]+/g, '').substr(0, len);
    },

    formatValue(att, val) {
        if (att.type === 'string') {
            if (val === null || val.length === 0) {
                return null;
            } else if (att.format === 'email') {
                return `<a href="mailto:${val}">${val}</a>`;
            } else if (att.format === 'url') {
                return `<a href="${val}" target="_blank">${val}</a>`;
            }
        } else if (att.type === 'number') {
            if (val === null || val.length === 0) {
                val = 0;
            }
            if (att.format === 'currency') {
                val = parseFloat(val) || 0;
                return CurrencyUtil.format(val / 100);
            } else {
                val = parseFloat(val) || 0;
                return numeral(val).format('0,0.[00]');
            }
        } else if (att.type === 'boolean') {
            if (att.format === 'true-false') {
                return Number(val) === 0 ? 'False' : 'True';
            } else if (att.format === 'on-off') {
                return Number(val) === 0 ? 'Off' : 'On';
            } else {
                return Number(val) === 0 ? 'No' : 'Yes';
            }
        } else if (att.type === 'date') {
            if (val === null || val.length === 0) {
                return null;
            } else if (att.format === 'date-time') {
                return (isNaN(val) ? moment(val) : moment.unix(parseInt(val))).format('MM/DD/YYYY h:mm A');
            } else if (att.format === 'relative') {
                return (isNaN(val) ? moment(val) : moment.unix(parseInt(val))).fromNow();
            } else {
                return (isNaN(val) ? moment(val) : moment.unix(parseInt(val))).format('MM/DD/YYYY');
            }
        } else if (val === null || val.length === 0) {
            return null;
        }
        return val;
    }

}